import { ajax } from "jquery";
import fileDownload from 'js-file-download';
import moment, { isMoment } from "moment";
import { registerLocale } from 'react-datepicker';
import Encoding from 'encoding-japanese';
import * as CONST from './const';
import ja from "date-fns/locale/ja";

class Utils {
    static getTranslateValue(reference, key) {
        if (reference == null || !reference.state.loadSuccess) {
            return "結果取得中...";
        }
        return reference.getValue(key);
    }

    static registerJapaneseLocale() {
        var jaLocale = {
            ...ja,
            options: {
              weekStartsOn: 0, firstWeekContainsDate: 1
            }
        }
        registerLocale('ja', jaLocale);
        return jaLocale;
    }

    static isNullOrEmpty(str) {
        return (!str || 0 === str.length) || (!str || /^\s*$/.test(str)) || str == undefined;
    }

    static updateListByNinushiCode(list, ninushiCode) {
        let optionList = [];
        if(list.length == 0){
            return optionList;
        }
        optionList.push(list[0]);// blank
        var currentIdx= 1;
        if(!this.isNullOrEmpty(ninushiCode)){
            list.map(function (option, index) {
                if (ninushiCode == option.NinushiCode) {
                    option.value = currentIdx;
                    optionList.push(option);
                    currentIdx++;
                }
            });
        }
        return optionList;
    }

    static csvFileDownload(url, list) {
        let fileName = moment().format(CONST.CSVDateFormat);
        ajax({
            url: url,
            type: 'GET',
            data: { rows: JSON.stringify(list) },
            credentials: 'same-origin'
        }).done(response => {
            fileDownload("\uFEFF" + response, fileName + ".csv", 'text/csv');
        });
    }

    static pdfFileDownload(url, model) {
        // let fileName = moment().format(CONST.CSVDateFormat);
        // get({ url: url, data:{ 'filterData':JSON.stringify(model) } }, response => {
        //     fileDownload("\uFEFF" + response, fileName + ".pdf", 'application/pdf');
        // });        
        let params = `?filterData=${encodeURIComponent(JSON.stringify(model))}`;
        window.location = url + params;
    }

    static excelFileDownload(url, fileName) {
        let params = `?fileName=${fileName}`;
        window.location = url + params;
    }

    /** Date values to send to server. */
    static getValidDate(date) {
        if(null != date) {
            if(date instanceof String || date instanceof Date) {
                return moment(date).format(CONST.DateFormat)
            } else if (isMoment(date)) {
                return date.format(CONST.DateFormat)
            }
        }
        return null;
    }

    /** Convert date values from server to a valid JS date. */
    static convertToDate(date, format) {
        try {
            if (Utils.isNullOrEmpty(date)) {
                return null;
            } else {
                if (Utils.isNullOrEmpty(format)) {
                    return new Date(moment(date));
                } else {
                    return new Date(moment(date, format));
                }
            }
        } catch (e) {
            return null;
        }
    }
    
    /** Convert date values from client to zaikoym code */
    static getZaikoYM(zaikoDate) {
        if(null != zaikoDate) {
            if(zaikoDate instanceof String || zaikoDate instanceof Date) {
                return moment(zaikoDate).format(CONST.ZAIKOYMFormat);
            }
        }
        return null;
    }


    static activeMenu(active){
        $('.main-menu li.active').removeClass('active');
        var idMenuActive = active;
        var $itemActive = $(idMenuActive);
        var $parentActive = $itemActive.parent();

        if ($parentActive.hasClass("sub-menu")) {
            var $parentLi = $itemActive.parent().parent();
            var $hyperlinkActive = $parentLi.find('a.js-sub-menu-toggle');
            $hyperlinkActive.trigger('click');
        }
        $itemActive.addClass("active");
    }
    static updateScreenTitle(title){
        if(title != null && title != 'undefined' && title != "結果取得中..."){
            document.title = "岡山大鵬薬品資材請求サイト | "+ title;
        }
    }

    static getCurrentNinushiCode() {
        let ninushi = sessionStorage.ninushi;
        return null != ninushi
          && undefined != ninushi
          && "" != ninushi ? JSON.parse(ninushi).NinushiCode : "";
    }

    // parameter format: YYYYMM, return format: YYYY/MM
    static buildZaikoYm(currentZaikoYm) {
        try {
            let year = currentZaikoYm.substring(0, 4);
            let month = currentZaikoYm.substring(4);
            if(Utils.isNullOrEmpty(year) && Utils.isNullOrEmpty(month)) {
                return null;
            }
            return year + "/" + month;
        } catch(e) {
            return null;
        }
    }

    static buildTabletList(source, currentList, currentPage, sizePerPage) {
        let newList = null == currentList ? [] : [...currentList];
        let newPageNo = currentPage;
        if(null != source) {
            let currentIndex = currentPage * sizePerPage;
            let newSetOfRecords = [...source].splice(currentIndex, sizePerPage);
            newList.push(...newSetOfRecords);
            newPageNo++;
        }
        return { list: newList, page: newPageNo };
    }

    // Use when currently displayed data has records updated / deleted
    static rebuildTabletList(source, currentPage, sizePerPage) {
        let currentPageNo = currentPage;
        let index = 0;
        let newList = [];
        while(index != currentPageNo) {
          let bList = Utils.buildTabletList(source, newList, index, sizePerPage);
          newList = bList.list;
          index++;
        }
        return newList;
    }

    static buildOptionList(sourceList, labelKey, dbKey, selectedKey, spKey = null, keyIsLabel = false, hasEmptyOption = true) {
        let optionList = null == hasEmptyOption || true == hasEmptyOption ? [{ value: 0, label: "", dbdata: null }] : [];
        let selectedIndex = 0;
        let selectedSpData = null;
        let selectedDbData = null;
        let isExist = false; // if selectedKey exists or not
        try {
            if(null != sourceList) {
                if(false == hasEmptyOption && sourceList.length > 0) {
                    let selected = sourceList[0];
                    selectedDbData = selected[dbKey];
                    selectedSpData = selected[spKey];
                }
                sourceList.map((element, index) => {
                    let currentIndex = hasEmptyOption == true ? index + 1 : index;
                    let option = { value: currentIndex, label: element[labelKey], dbdata: element[dbKey] };
                    if(null != spKey) {
                        option.spdata = element[spKey];
                    }
                    optionList.push(option);
                    if(selectedIndex == 0 && selectedKey != null) {
                        if(keyIsLabel) {
                            if (element[labelKey] == selectedKey) {
                                selectedIndex = option.value;
                                selectedSpData = option.spdata;
                                selectedDbData = option.dbdata;
                                isExist = true;
                            }
                        } else {
                            if (element[dbKey] == selectedKey) {
                                selectedIndex = option.value;
                                selectedSpData = option.spdata;
                                selectedDbData = option.dbdata;
                                isExist = true;
                            }
                        }
                    }
                });
            }
        } catch (e) {}
        return { options: optionList, selectedIndex: selectedIndex, selectedSpData: selectedSpData, selectedDbData: selectedDbData, isExist: isExist };
    }
   
    static IsFileImage(file) {
        const validImageTypes = ['image/gif', 'image/jpg','image/jpeg', 'image/png'];
        return file && ($.inArray(file['type'], validImageTypes) !== -1)
    }

    static scrollToTop() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }
    }
    static convertToShiftJIS(target) {
        const uniArray = Encoding.stringToCode(target);
        const sjisArray = Encoding.convert(uniArray, {
          to: 'SJIS',
          from: 'UNICODE'
        });
        // const sjisString = Encoding.codeToString(sjisArray);
        const unit8Array = new Uint8Array(sjisArray);
        return unit8Array;
    }
}
export default Utils;


// WEBPACK FOOTER //
// ./helpers/utils.jsx